import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import IconButton from '../../IconButton';
import PrimaryButton from '../../PrimaryButton';
import CheckIcon from '../../../../public/assets/images/theme-2/icons/handin-hover.svg';
import { ViewSection, LockInfo } from '../styles';
import {
  SubmitPanel,
  Glossary,
  GlossaryHeader,
  GlossaryBody,
  GlossaryRow,
  GlossaryConcept,
  GlossaryDescription,
} from '../../NodeContentPreview/styles';

const GlossaryContentViewer = ({ data, isEditable, report, saveReport, isTeacher, theme }) => {
  const [concepts, setConcepts] = useState([]);

  const isLocked = report?.locked;

  useEffect(() => {
    setConcepts(data?.CorrelationList?.Concepts || []);
  }, []);

  const handinReport = () => {
    saveReport({ ...report, state: 'accept' });
  };

  const resetReport = () => {
    saveReport({ ...report, state: 'active' });
  };

  return (
    <>
      <ViewSection>
        <Glossary>
          <GlossaryHeader>
            <GlossaryConcept>{i18n.__('correlation_term')}</GlossaryConcept>
            <GlossaryDescription>{i18n.__('correlation_description')}</GlossaryDescription>
          </GlossaryHeader>
          <GlossaryBody>
            {concepts.map((concept, index) => (
              <GlossaryRow key={concept.id} even={index % 2}>
                <GlossaryConcept dangerouslySetInnerHTML={{ __html: concept.body }} />
                <GlossaryDescription dangerouslySetInnerHTML={{ __html: concept.Description.body }} />
              </GlossaryRow>
            ))}
          </GlossaryBody>
        </Glossary>
      </ViewSection>
      {!isTeacher && (
        <SubmitPanel className={'ir-hide'}>
          {isLocked ? (
            <LockInfo>{i18n.__('editor_locked_desc')}</LockInfo>
          ) : isEditable ? (
            <IconButton
              icon={CheckIcon}
              onClick={handinReport}
              disabled={isTeacher}
              backgroundColor={theme.colors.buttonGreenFront}
            >
              {i18n.__('app_done')}
            </IconButton>
          ) : (
            <PrimaryButton onClick={resetReport} text={i18n.__('app_reset')} className="reset" />
          )}
        </SubmitPanel>
      )}
    </>
  );
};

export default withTheme(GlossaryContentViewer);

GlossaryContentViewer.propTypes = {
  data: PropTypes.object.isRequired,
  isEditable: PropTypes.bool.isRequired,
  report: PropTypes.object,
  saveReport: PropTypes.func.isRequired,
  isTeacher: PropTypes.bool.isRequired,
};
